import { Col } from "@commonlibs";
import styled, { css } from "styled-components";
import { ThemeSpacingKeys } from "ui/config/theme/spacing";
import { FormProps } from "./Form";

export const FORM_ROW_GAP: ThemeSpacingKeys = 6;

export const FormWrapper = styled(Col)<Partial<Pick<FormProps, "gap">>>(
    ({ theme, gap = FORM_ROW_GAP }) => css`
        row-gap: ${theme.spacing[gap]};
        flex: 1;
    `,
);
